<script setup lang="ts">
    import { computed, inject, watch } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import EventIssues from '@views/Event/EventIssues.vue';
    import { toEventRefs, getEventSegmentId } from '@views/Event/Event';
    import { type Event, type EventSegmentRelation } from '@views/Event/EventTypes';
    import { eventKey, canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    const props = defineProps<{
        eventId: string;
    }>();

    const event = inject(eventKey)!;
    const canEdit = inject(canEditKey)!;
    const route = useRoute();
    const router = useRouter();

    // Links from an issue (?issueId=) land here; confirmation/attestation mailings live on their own tabs.
    watch(
        event,
        (value) => {
            const issueId = route.query.issueId;
            if (!value || !issueId) return;

            if (issueId === value.ParticipantStatusChangeIssueId) {
                router.replace({ name: 'EventEditorConfirmations', params: { eventId: props.eventId } });
            } else if (issueId === value.AttestationIssueId) {
                router.replace({ name: 'EventEditorAttestation', params: { eventId: props.eventId } });
            }
        },
        { immediate: true }
    );

    const eventRefs = computed(() => (event.value ? toEventRefs(event.value) : null));
    const getSegmentId = (relation: EventSegmentRelation) => getEventSegmentId(event.value, relation);
</script>

<template>
    <EventIssues v-if="eventRefs" :event="eventRefs" :getSegmentId="getSegmentId" :updateEnabled="canEdit" />
</template>

